<template>
  <div class="menu-layout-container" >
    <el-header class="header_wrapper common_bg" height="50px" v-show="$route.name != 'login'">
      <div class="header_left">
        <img class="logo" :src="logo" @click="goHome" style="height: 30px; margin-top: 10px;" />
      </div>
      <div class="header_right">
        <ul>
          <li @click="$router.push('/list')" v-show="hasPerms('projectMgr')">
            项目管理
          </li>
          <li @click="$router.push('/data-manage')" v-show="hasPerms('turbineTypeMgr')">
            机型管理
          </li>

          <el-dropdown
            v-for="(subMenu, i) in subMenus"
            :key="i"
            @command="toUrl"
            trigger="click"
            placement="bottom-start"
          >
            <li>{{ subMenu.text }}</li>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in subMenu.children"
                :key="item.text"
                :command="item.path"
                v-show="hasPerms(item.codes[0])"
                >{{ item.text }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>

          <!-- <div class="login_info">
            <span class="img"></span>
            <span class="name">yumang</span>
          </div>-->
        </ul>
        <el-button type="text" @click="handleLoginClick" v-if="!user"
          >登录</el-button
        >
        <div>
          <el-dropdown
            class="login-info"
            trigger="hover"
            v-if="user"
            @command="handleCommand"
          >
            <span class="el-dropdown-link name">
              <i class="iconfont icontouxiang"></i>
              {{ user ? user.name : '' }}
              <i class="iconfont iconjiantouarrow486"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="change">修改密码</el-dropdown-item>
              <el-dropdown-item command="exit">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>
    <div class="main-core-content">
      <slot></slot>
    </div>
    <el-dialog
      v-drag:common
      class="login-dialog"
      :modal="false"
      title="登录"
      width="400px"
      :visible="visible"
      :before-close="handleCloseClick"
    >
      <el-form
        label-position="right"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        :model="form"
        class="login-form"
      >
        <el-form-item label="用户名" prop="userCode">
          <el-input
            class="clean-el-input-left text-left"
            v-model="form.userCode"
            @keydown.enter.native="handleLoginSureClick"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            class="clean-el-input-left text-left"
            v-model="form.password"
            @keydown.enter.native="handleLoginSureClick"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex-reverse">
        <div class="btn-wrapper">
          <ct-button size="small" :btn-click="handleResetClick">重置</ct-button>
          <ct-button
            size="small"
            type="primary"
            :btn-click="handleLoginSureClick"
            >登录</ct-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      v-drag:common
      class="login-dialog"
      :modal="false"
      title="修改密码"
      width="400px"
      :visible="changeVisible"
      :before-close="handleChangeCloseClick"
    >
      <el-form
        label-position="right"
        :rules="changeRules"
        ref="changeRuleForm"
        label-width="100px"
        :model="changeForm"
        class="login-form"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            type="password"
            class="clean-el-input"
            v-model="changeForm.oldPassword"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            class="clean-el-input"
            type="password"
            v-model="changeForm.newPassword"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="newPassword2">
          <el-input
            class="clean-el-input"
            type="password"
            v-model="changeForm.newPassword2"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex-reverse">
        <div class="btn-wrapper">
          <!--ct-button size="small" :btn-click="handleChangeResetClick"
            >重置</ct-button
          -->
          <ct-button size="small" type="primary" :btn-click="handleSureClick"
            >确认</ct-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 注意此文件会在没有router的环境下使用，请谨慎使用全局router相关的变量
 * 本文件会拷贝到其他项目使用，
 */
import { mapState } from 'vuex';
import { getToken, setToken, safeSetSessionStorage } from '@/utils';
import { hasPermission } from '@/permission/index';

export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changeForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      navList: [],
      logo: require('@/asset/logo.png'),
      rules: {
        userCode: [{ required: true, message: '请输入用户名' }],
        password: [{ required: true, message: '请输入密码' }]
      },
      changeRules: {
        newPassword: [{ required: true, message: '请输入新密码' }],
        newPassword2: [
          { required: true, validator: validatePass2, trigger: blur }
        ],
        oldPassword: [{ required: true, message: '请输入旧密码' }]
      },
      feedbackRules: {
        title: [{ required: true, message: '请输入标题' }],
        content: [{ required: true, message: '请输入反馈内容' }]
        //phone: [{type: 'number', message: '手机号必须为数字值'}]
      },
      visible: false,
      changeVisible: false,
      form: {
        userCode: null,
        password: null
      },
      changeForm: {
        newPassword: '',
        newPassword2: '',
        oldPassword: ''
      },
      feedbackForm: {
        title: '',
        content: '',
        phone: ''
      },
      activeIndex: '',
      subMenus: []
    };
  },

  watch: {
    $route: {
      handler(val, prev) {
        const { name: prevName } = prev;
        const { name = '', query = {} } = val;
        const { callbackUrl = '' } = query;
        this.highLightTab(val);
        if (
          name === 'project-list' &&
          prevName !== 'project-list' &&
          callbackUrl
        ) {
          this.checkLogin().then(res => {
            if (!res) {
              this.handleLoginClick();
            } else {
              this.$router.replace({
                path: callbackUrl
              });
            }
          });
        }
      },
      deep: true
    }
  },
  created() {
    this.highLightTab();
  },
  mounted() {
    this.checkLogin();
  },
  methods: {
    hasPerms(perms) {
      //  console.log(perms)
      return hasPermission(perms);
      //  for(var i=0;i<perms.length;i++){
      //   console.log(perms[i].codes)
      //    for(var j =0;j<perms[i].codes.length;j++){
      //      return hasPermission(perms[i].codes[j]);
      //  }
      //  }

      //  for(var i=0;i<perms.length;i++){
      //    console.log(perms[i])
      //    return hasPermission(perms[i]);
      // //    for(var j =0;j<perms[i].codes.length;j++){
      // //      return hasPermission(perms[i].codes[j]);
      // //  }
      //  }

      // 根据权限标识和外部指示状态进行权限判断
    },
    handleChangeResetClick() {
      this.$refs.changeRuleForm.resetFields();
    },
    handleSureClick() {
      this.$refs.changeRuleForm.validate(valid => {
        if (valid) {
          this.$postForm('/windfarm/updateUserPassword', {
            data: {
              ...this.changeForm
            },
            showSuccess: true,
            showError: true
          }).then(() => {
            this.changeVisible = false;
            this.checkLogin();
          });
        }
      });
    },
    handleCommand(command) {
      if (command === 'exit') {
        this.$confirm('是否确认退出', '提醒', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$postForm('/windfarm/doLogout', {
              module: 'manage',
              showLoading: true,
              data: {
                apiKey: getToken()
              },
              showError: true,
              showSuccess: true
            }).then(() => {
              setToken('');
              safeSetSessionStorage('selectMenu', '');
              this.$router.replace({path: '/login'});
              this.$store.commit('SET_USER', null);
            });
          })
          .catch(() => {});
      }

      if (command === 'change') {
        this.changeVisible = true;
      }
    },

    handleChangeCloseClick() {
      this.handleChangeResetClick();
      this.changeVisible = false;
    },
    handleCloseClick() {
      this.handleResetClick();
      this.visible = false;
    },

    handleLoginSureClick() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$postForm('/windfarm/doLogin', {
            showError: true,
            showSuccess: true,
            showLoading: true,
            data: {
              ...this.form
            }
          }).then(res => {
            const { data = {} } = res;
            const { user = {} } = data;
            const { apikey = '', functionMenu = {} } = user;
            setToken(apikey);
            let permissionList = functionMenu.map(item => {
              return item.functionCode;
            });
            this.$store.commit('SET_USER', res.data?.user);
            this.$store.commit('SET_PERMISSION', permissionList);
            this.handleCloseClick();
            const { callbackUrl = '' } = this.$route.query;

            if (this.$route.name === 'list') {
              location.reload();
            }
            if (callbackUrl) {
              this.$router.replace({
                path: callbackUrl
              });
            }
          });
        }
      });
    },

    handleResetClick() {
      this.$refs.ruleForm.resetFields();
    },

    handleFeedbackResetClick() {
      this.$refs.feedbackForm.resetFields();
    },

      handleLoginClick() {
        this.$router.push('/login');
        // this.visible = true;
      },

    checkLogin() {
      return this.$postForm('/windfarm/checkLogin', {
        showError: true,
        data: {
          apiKey: getToken()
        }
      }).then(res => {
        const { data, code = '' } = res || {};
        if (code === 0) {
          this.$store.commit('SET_USER', data?.user);
          let permissionList = data?.user.functionMenu.map(item => {
            return item.functionCode;
          });
          console.log(permissionList);
          this.$store.commit('SET_PERMISSION', permissionList);
          return true;
        }
        this.handleLoginClick();
        this.$store.commit('SET_USER', null);
        this.$store.commit('SET_PERMISSION', null);
        return false;
      });
    },

    toUrl: function(path) {
      let apiKey = localStorage.getItem('apiKey');
      if (!apiKey) {
        this.handleLoginClick();
        return;
      }
      this.activeIndex = path;
      if (!this.$route) {
        if (location.pathname === path) return;
        location.href = `/#${path}`;
        return;
      }
      if (path === this.$route.path) return;
      if (path === '/flow.html') {
        // flow 是另一个html页面，不是单页
        location.href = path;
      } else {
        this.$router.push(path);
      }
    },
    goHome() {
      if (!this.$route) {
        location.href = `/`;
        return;
      }
      this.$router.push('/');
    },
    highLightTab(route) {
      let { path } = route || this.$route || {};
      if (!path) {
        path = '/wind-farm';
      }
      const item = this.navList?.find(v => path.indexOf(v.path) !== -1);
      if (item) {
        this.activeIndex = item.path;
      }
    }
  },
  computed: {
    ...mapState(['user']),
    isRoot() {
      return this.$route && this.$route.name === 'root';
    }
  }
};
</script>
<style lang="less" scoped>
  .login {
    width: 100%;
    height: 100%;
  }
/*
.btn-wrapper {
  display: flex;
  justify-content: space-around;
}

// div /deep/.el-input--mini .el-input__inner {
//   height: 34px;
//   line-height: 34px;
//   width: 215px;
// }

 div /deep/.el-form-item {
    margin-bottom: 18px;
    margin-left: 20px;
  } 

div /deep/.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

div /deep/ .el-dialog .el-dialog__footer {
  background-color: #081a29;
  height: 52px;
  //border: 1px solid#FFF;
  border-top: none;
}

div /deep/ .ct-btn-default {
  background: #081a29;
  border: 1px solid #fff;
  color: #fff;
}
*/
.login-bg {
  width: 100%;
  height: 100%;
  /* background: #051120; */
  background: linear-gradient(to bottom, #051120 0%, #020913 100%);
  z-index: -1;
  position: absolute;
}
.el-dropdown {
  cursor: pointer;
}
// .header_wrapper {
.el-dropdown-menu,
.el-dropdown-menu--mini {
  width: 100px;
  text-align: center;
  max-height: 250px;
  //background: linear-gradient(180deg, #ffffff, #f2f7fc);
  background: #fff;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.el-dropdown-menu--mini .el-dropdown-menu__item {
  line-height: 30px;
  padding: 0 25px;
  font-size: 14px;
  margin: 8px 0;
  height: 30px;
}

.el-dropdown-menu__item {
  height: 30px;
  border-radius: 5px;
  list-style: none;
  line-height: 30px;
  padding: 0 10px;
  margin: 0;
  font-size: 14px;
  cursor: pointer;
  outline: 0;
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: #e8f4ff;
  color: #46a6ff;
}

.el-dropdown-menu__item i {
  margin-right: 15px;
}

// }
</style>
<style lang="less" scoped>
.menu-layout-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .main-core-content {
    height: 100%;
    width: 100%;
    overflow: auto;
  }
}
.login-txt {
  padding-left: 20px;
  cursor: pointer;
}
.login-info {
  padding-left: 20px;

  .name {
    cursor: pointer;
    color: #f7f7f7;

    .icontouxiang {
      font-size: 30px;
      margin-right: 5px;
      color: #f7f7f7;
    }
    i {
      vertical-align: middle;
      color: #f7f7f7;
    }
  }
}

.header {
  &_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1000;

    background-color: rgb(60, 141, 188);
    color: #f7f7f7;
  }

  &_right {
    display: flex;
    align-items: center;
    ul {
      display: flex;
      font-size: 14px;
      color: #f7f7f7;
      align-items: center;
      li {
        padding: 0 28px;
        cursor: pointer;
        color: #f7f7f7;
      }
    }
  }
  &_left {
    font-size: 20px;
    color: #ffffff;
  }
}
.login_info {
  display: flex;
  align-items: center;
  .img {
    width: 32px;
    height: 32px;
    background: inherit;
    background-color: rgba(255, 255, 255, 0.4588235294117647);
    border: none;
    border-radius: 15px;
    color: #ffffff;
    display: inline-block;
    margin-right: 5px;
    margin-left: 20px;
  }
  .name {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.4470588235294);
  }
}
</style>
